import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,

    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDeDetalhe } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import {  ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { ApostaService, IDadosClassificacao, IDadosMinhasApostas } from "../../shered/services/api/apostas/ApostasService";
import { useVForm } from "../../shered/forms";



export const ListagemDeClassificacaoAposta: React.FC = () => {
    const theme = useTheme();
    const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { save, saveAndClose, } = useVForm();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [lstClassificacao, setLstClassificacao] = useState<IDadosClassificacao[]>();    
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [listaStats, setListaStats] = useState<ILstDrop[]>([]);

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });
    
    const columnsClassificacaoGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'posicao',
            headerName: UtilidadeService.isMobile() ? 'POS.' : "POSIÇÃO",
            flex: 1,

            minWidth: UtilidadeService.isMobile() ? 60 : 70,
            maxWidth: UtilidadeService.isMobile() ? 60 : 90,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'foto_Usuario',
            headerName: 'FOTO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 60,
            maxWidth: 80,
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <img src={params.value === null ? semImagem : params.value} width={45} height={50} />,
        },
        {
            field: 'nome_Usuario',
            headerName: 'NOME',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'pontos',
            headerName: 'PONTOS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 120 : 130,
            maxWidth: UtilidadeService.isMobile() ? 120 : 160,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
    ];

    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        debounce(() => {
            UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;

                });

            setSemImagem(user.imagem_Perfil !== null ? user.imagem_Perfil : semImagem);
            LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;
                    setDadosLiga(liga);

                    setTemporadaFiltro(liga.codigo_Temporada);
                    carregarDados(liga.codigo_Temporada);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        })

    }, []);

    const carregarDados = async (codigoTemporada: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        await ApostaService.getClassificacao(codigoTemporada)
            .then((result) => {
                const dados = result.dado;
                setLstClassificacao(dados);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        carregarDados(e.target.value);
    }

    return (
        <LayoutBaseDePagina
            titulo={`Classificação Apostas`}
            showLogoImg={semImagem}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Classificação </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Classificação </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} style={{ paddingTop: "16px" }}>

                                {lstClassificacao != undefined && lstClassificacao.length > 0 ? (
                                    <Grid container size={{ xs: 12, sm: 12 }}>
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <Box
                                                sx={{
                                                    height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                        color: "#00e676",
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell': {
                                                        color: '#00e676',
                                                        fontWeight: '600',
                                                    },
                                                }}>
                                                <DataGrid
                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                    getRowId={(r) => r.codigo}
                                                    rows={lstClassificacao}
                                                    columns={columnsClassificacaoGeral}
                                                    initialState={{
                                                        pagination: {
                                                            paginationModel: {
                                                                pageSize: 24,
                                                            },
                                                        },
                                                    }}
                                                    columnVisibilityModel={{
                                                        codigo: false,
                                                    }}
                                                    disableDensitySelector
                                                    disableVirtualization
                                                    pageSizeOptions={[12, 24, 32, 50, 75, 100]}
                                                    disableRowSelectionOnClick
                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                    hideFooter
                                                    sx={{
                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                    }}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )
                                    :
                                    <Grid size={{ xs: 12, sm: 12 }} >
                                        <Box
                                            sx={{
                                                height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',                                               
                                            }}>
                                            <Typography variant="h6">Não possui dados para a temporada selecionada!</Typography>
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina >
    )
}


